import styled from 'styled-components';
import { rem } from 'polished';
import Emoji from '@atresmedia/intranet-emoji';

const StyledIconWrapper = styled.div`
  text-align: center;
  margin-bottom: ${rem('10px')};
`;

const StyledEmoji = styled(Emoji)`
  width: ${rem('36px')};
`;

const StyledTitle = styled.h2`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('16px')};
  margin: ${rem('5px')} 0 0 0;
  font-weight: 400;
  @media (min-width: ${props => props.theme.mediaqueries.desktop}) {
    font-size: ${rem('18px')};
  }
`;

export { StyledIconWrapper, StyledEmoji, StyledTitle };
